import axios from "axios";
import { GetUrl } from "../api/endpointConfig";
import { BLOB_API } from "../config/config";

export const uploadFileToBlob = async ({
  file,
  formik,
  formikPath,
  index,
  onSuccess,
}: {
  file: File;
  formik: any;
  formikPath: string;
  index?: number;
  onSuccess?: (url: string, filename: string) => void;
}) => {
  try {
    const extension = file.name.split(".").pop()?.toLowerCase();
    if (!extension) return;

    const { data: sastokenInfo } = await axios.get(
      `${GetUrl.getSasToken}?file_type=${extension}`
    );

    const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
    const blobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64 = (reader.result as string).split(",")[1];
      const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

      const response = await axios.put(uploadUrl, buffer, {
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type,
        },
      });

      if (response.status === 200 || response.status === 201) {
        if (formikPath.includes("[") && index !== undefined) {
          const base = formikPath.split("[")[0]; // e.g., completedEducation
          const field = formikPath.split(".").pop(); // e.g., uploadMarksheet
          const formikArray = [...formik.values[base]];
          formikArray[index][field!] = blobUrl;
          formik.setFieldValue(base, formikArray);
        } else {
          formik.setFieldValue(formikPath, blobUrl);
        }

        onSuccess?.(blobUrl, sastokenInfo.filename);
      } else {
        console.error("Upload failed:", response.statusText);
      }
    };

    reader.readAsDataURL(file);
  } catch (err) {
    console.error("Upload error", axios.isAxiosError(err) ? err.response : err);
  }
};

export const getSecureBlobUrl = async ({
  fileName,
  blobBaseUrl,
  getTokenUrl,
}: {
  fileName: string | undefined;
  blobBaseUrl: string;
  getTokenUrl: string;
}): Promise<string | null> => {
  if (!fileName) {
    console.warn("File name is undefined or null.");
    return null;
  }

  try {
    const { data: accessTokenInfo } = await axios.get(`${getTokenUrl}?file_name=${fileName}`);
    if (accessTokenInfo?.token) {
      const baseBlobUrl = `${BLOB_API}/documents/`;
      if (!fileName.startsWith(baseBlobUrl)) {
        return `${blobBaseUrl}/documents/${fileName}?${accessTokenInfo.token}`;
      } else {
        return `${fileName}?${accessTokenInfo.token}`
      }
      // return `${blobBaseUrl}/documents/${fileName}?${accessTokenInfo.token}`;
    } else {
      console.warn("Token not received or invalid from SAS endpoint.");
      return null;
    }
  } catch (error) {
    console.error("Error while retrieving secure blob URL:", error);
    return null;
  }
};